import { render, staticRenderFns } from "./StockImport.vue?vue&type=template&id=74d3d247&"
import script from "./StockImport.vue?vue&type=script&lang=js&"
export * from "./StockImport.vue?vue&type=script&lang=js&"
import style0 from "./StockImport.vue?vue&type=style&index=0&id=74d3d247&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports